module.exports = __webpack_public_path__ + "images/163_640.jpg";